import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '@core/services';
import { ChildPermissionService } from '@core/services/child-permission.service';
import { AppGlobals } from 'src/app/app.global';

@Injectable()
export class LeadAdminGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private childPermissionService: ChildPermissionService,
        private router: Router,
        private appGlobals: AppGlobals
    ) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!this.authService.user.isLeadAdmin) {
            return false;
        }

        if (this.authService.user.isChildLeadAdmin) {
            // Check if user has permission for this route
            // The route path usually matches our key mapping or we can map them
            const path = state.url.split('?')[0];
            let menuKey = '';

            // Map paths to keys
            if (path.includes('/invoice-review-summary')) menuKey = 'invoice_summary';
            else if (path.includes('/buyer')) menuKey = 'buyer';
            else if (path.includes('/hyperpure-reports')) menuKey = 'hyperpure_reports';
            else if (path.includes('/deliverit-reports')) menuKey = 'deliverit_report';
            else if (path.includes('/purchase-manager/analytics')) menuKey = 'pm_analytics';
            else if (path.includes('/lead-admin-user-management')) menuKey = 'user_management';
            else if (path.includes('/child-lead-admin-management')) menuKey = 'child_lead_admin_management';
            else if (path.includes('/hyperpure-deactivation')) menuKey = 'hyperpure_deactivation';
            else if (path.includes('/utilities/invoice-reupload')) menuKey = 'invoice_reupload_utility';
            else if (path.includes('/utilities/invoice-ocr')) menuKey = 'invoice_ocr_utility';
            else if (path.includes('/utilities/merge-companies')) menuKey = 'merge_companies_utility';
            else if (path.includes('/utilities/clear-user-data')) menuKey = 'clear_user_data_utility';
            else if (path.includes('/utilities/invoice-ocr')) menuKey = 'invoice_ocr_utility';
            else if (path.includes('/utilities/failed-invoices')) menuKey = 'failed_invoices';

            if (menuKey) {
                const camelKey = this.childPermissionService.toCamelCase(menuKey);
                if (!this.childPermissionService.canAccessMenu(camelKey)) {
                    // Find first accessible menu instead of hardcoding /dashboard
                    let fallbackPath = '/dashboard';
                    let found = false;
                    for (const section of this.appGlobals.sidebarSections) {
                        if (found) break;
                        if (!section.menus) continue;
                        for (const menu of section.menus) {
                            const m = menu as any;
                            if (m.roles && m.roles.includes('leadAdmin') && m.key) {
                                const cKey = this.childPermissionService.toCamelCase(m.key);
                                if (this.childPermissionService.canAccessMenu(cKey)) {
                                    fallbackPath = m.path;
                                    found = true;
                                    break;
                                }
                            }
                        }
                    }
                    this.router.navigate([fallbackPath]);
                    return false;
                }
            }
        }

        return true;
    }
}